import { Title } from '@solidjs/meta'
import { useParams } from '@solidjs/router'
import { type Component, createEffect, createResource, onCleanup, Show } from 'solid-js'
import Card from '~/components/Card'
import GoBack from '~/components/GoBack'
import Skeleton from '~/components/Skeleton'
import PaymentAccountForm from '~/layers/ui/admin/cuentas-cobro/PaymentAccountForm'

import { paymentAccountService } from '~/services/payment-account.service'
import { setTrailOverride } from '~/stores/breadcrumb'

/**
 * Ficha de una cuenta de cobro existente (/admin/cuentas-cobro/:id). Comparte
 * el formulario con la creación; sólo cambia qué recurso se carga y el destino
 * tras guardar.
 */
const CuentaCobroPage: Component = () => {
  const params = useParams()
  const [account] = createResource(
    () => Number(params.id),
    async (id: number) => {
      try {
        return await paymentAccountService.get(id)
      } catch {
        return null
      }
    }
  )

  // Miga de pan propia: "Cuentas de Cobro › [número]". Se limpia al salir.
  createEffect(() => {
    const number = account()?.number
    setTrailOverride(['Cuentas de Cobro', number || 'Editar Cuenta de Cobro'])
  })
  onCleanup(() => setTrailOverride(null))

  return (
    <>
      <Title>Editar Cuenta de Cobro | Florez Jaramillo</Title>

      <Show
        when={!account.loading}
        fallback={
          <Card>
            <Card.Body>
              <div class="space-y-3">
                <Skeleton height="2rem" width="40%" />
                <Skeleton height="1rem" width="70%" />
                <Skeleton height="12rem" />
              </div>
            </Card.Body>
          </Card>
        }
      >
        <Show
          when={account()}
          fallback={
            <Card>
              <Card.Body>
                <div class="text-center py-10 space-y-4">
                  <p class="text-foreground-subtle">No pudimos cargar esta cuenta de cobro. Puede que ya no exista.</p>
                  <GoBack label="Volver a cuentas de cobro" fallbackPath="/admin/cuentas-cobro" />
                </div>
              </Card.Body>
            </Card>
          }
        >
          {data => <PaymentAccountForm account={data} />}
        </Show>
      </Show>
    </>
  )
}

export default CuentaCobroPage
